import {
  LoaderFunction,
  useLoaderData,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { get } from "api";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import { IconButton } from "atoms/icon-button/IconButton";
import { queryClient } from "pages/Root";
import { loadIfFlag } from "services/Flags";
import { waitObj } from "toolbox/Promise";

type SetAppointmentUrlParams = {
  appointmentTypeId: number;
  providerId: number;
  healhtieUserId: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
};

const setAppointmentUrl = ({
  appointmentTypeId,
  providerId,
  healhtieUserId,
  firstName,
  lastName,
  email,
  phone,
}: SetAppointmentUrlParams) => {
  const urlString = process.env.REACT_APP_OPEN_LOOP_BOOKING_URL;
  if (!urlString) throw new Error("REACT_APP_OPEN_LOOP_BOOKING_URL is missing");
  const url = new URL(urlString);

  const redirectUrl = `${window.location.origin}/health/glp/booking?appointmentCompleted=true`;

  url.searchParams.append("appointmentTypeId", appointmentTypeId.toString()); // TODO: Ask OpenLoop for the correct appointmentTypeId
  url.searchParams.append("providerId", providerId.toString()); //TODO: Ask OpenLoop for the correct providerId
  url.searchParams.append("headless", "true");
  url.searchParams.append("pid", healhtieUserId.toString());
  url.searchParams.append("firstName", firstName || "");
  url.searchParams.append("lastName", lastName || "");
  url.searchParams.append("email", email || "");
  url.searchParams.append("phoneNumber", phone || "");
  url.searchParams.append("redirectUrl", redirectUrl);
  return url;
};

const loader = async () => {
  const user = await queryClient.fetchQuery(["/user"], () => get("/user"));
  const modality = localStorage.getItem("patientModality");
  if (modality !== "sync_visit" || !user.healthieUserId)
    return waitObj({ iframeUrl: null });

  const iframeUrl = setAppointmentUrl({
    appointmentTypeId: 167712,
    providerId: 1234,
    healhtieUserId: user.healthieUserId,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    phone: user.phoneNumber,
  });

  return waitObj({ iframeUrl });
};

type LoaderData = Awaited<ReturnType<typeof loader>>;
export const glpBookingLoader: LoaderFunction = loadIfFlag("repeatmd-glp")(
  () => {
    return loader();
  }
);
const BookingPage = () => {
  const { iframeUrl } = useLoaderData() as LoaderData;
  const [searchParams] = useSearchParams();
  const appointmentCompleted =
    searchParams.get("appointmentCompleted") === "true";
  const navigate = useNavigate();
  const goPreviousStep = () => {
    navigate(-1);
  };

  if (!iframeUrl) {
    navigate("/");
    return null;
  }

  return (
    <div className="flex h-full flex-col gap-3">
      {appointmentCompleted ? (
        <div className="flex flex-col items-center justify-center gap-3">
          <p className="bg-green-100 p-3 text-center text-body1 text-green-800">
            Your appointment has been booked successfully!
          </p>
          <a
            className="rounded bg-brand-color p-2 text-white enabled:hover:bg-gradient-to-t enabled:hover:from-white/10 enabled:hover:to-white/10 enabled:active:bg-gradient-to-t enabled:active:from-white/20 enabled:active:to-white/20"
            href={`${window.location.origin}/`}
            target="_top"
          >
            Continue
          </a>
        </div>
      ) : (
        <>
          <div className="flex w-full items-center justify-between gap-3 border-b-2 border-gray-50 bg-white bg-opacity-95 pt-[env(safe-area-inset-top)]">
            <div className="flex items-center">
              <IconButton
                svg={ChevronLeft}
                onClick={goPreviousStep}
                size="small"
                style="iconOnly"
              />
            </div>
            <p className="text-md text-bold1">Book Appointment</p>
            <div className="p-[20px]"></div>
          </div>
          <iframe
            src={iframeUrl?.toString()}
            width="100%"
            height="100%"
            loading="lazy"
          ></iframe>
          <div className="h-3"></div>
        </>
      )}
    </div>
  );
};

export default BookingPage;
